<template>
    <div style="margin-top:-70px;min-height: 250px;">
        <v-card class="mx-auto my-12" max-width="450" elevation="0">
            <v-container grid-list-xl justify-space-around wrap fluid>

                <!-- Profile view: user information + actions -->
                <div v-if="resetPinStep === 'none'">
                    <v-list two-line>
                        <v-list-item>
                            <v-list-item-avatar color="#0F9750">
                                <v-icon dark>mdi-account</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title class="profile_name">{{ customer_name || '—' }}</v-list-item-title>
                                <v-list-item-subtitle class="profile_phone">
                                    <v-icon small color="#0F9750">mdi-phone</v-icon>
                                    {{ masked_mobile_no }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>

                    <v-divider class="my-2"></v-divider>

                    <!-- Reset PIN -->
                    <v-list-item @click="startResetPin" style="cursor:pointer">
                        <v-list-item-icon>
                            <v-icon color="#0F9750">mdi-lock-reset</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="account_text2">Reset PIN</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-icon>
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-list-item-icon>
                    </v-list-item>
                </div>

                <!-- Reset PIN: OTP verification step -->
                <div v-if="resetPinStep === 'otp'">
                    <p class="reset_title">Reset PIN</p>
                    <v-card-subtitle class="text-center" style="padding-top:0">
                        Enter the OTP sent to {{ masked_mobile_no }}
                    </v-card-subtitle>
                    <v-text-field
                        v-model="otp"
                        label="OTP"
                        type="text"
                        inputmode="numeric"
                        maxlength="6"
                        outlined
                        dense
                        @keypress="onlyAllowNumbers($event)"
                        @keydown.enter.prevent="continueResetPin"
                    ></v-text-field>
                    <v-btn color="primary" block @click="continueResetPin" :disabled="otp.length < 4">
                        Continue
                    </v-btn>
                    <div class="text-center mt-2">
                        <v-btn text small @click="cancelReset" style="color:#0F9750;margin-right:8px">Cancel</v-btn>
                        <v-btn text small @click="startResetPin" :disabled="resendDisabled">
                            Resend OTP {{ resendTimer > 0 ? `(${resendTimer}s)` : '' }}
                        </v-btn>
                    </div>
                </div>

                <!-- Reset PIN: set new PIN step -->
                <div v-if="resetPinStep === 'set'">
                    <p class="reset_title">Set a new 4-digit PIN</p>
                    <v-text-field
                        v-model="newPin"
                        label="New PIN"
                        type="password"
                        inputmode="numeric"
                        maxlength="4"
                        outlined
                        dense
                        @keypress="onlyAllowNumbers($event)"
                    ></v-text-field>
                    <v-text-field
                        v-model="newPinConfirm"
                        label="Confirm New PIN"
                        type="password"
                        inputmode="numeric"
                        maxlength="4"
                        outlined
                        dense
                        @keypress="onlyAllowNumbers($event)"
                        @keydown.enter.prevent="submitResetPin"
                    ></v-text-field>
                    <v-btn
                        color="primary"
                        block
                        @click="submitResetPin"
                        :disabled="newPin.length < 4 || newPinConfirm.length < 4"
                    >
                        Reset PIN
                    </v-btn>
                    <div class="text-center mt-2">
                        <v-btn text small @click="cancelReset" style="color:#0F9750">Cancel</v-btn>
                    </div>
                </div>

            </v-container>
        </v-card>

        <v-snackbar
          v-model="snackbar"
          :color="color"
          :timeout="timeout"
          :top="true"
          rounded="pill"
        >{{ popup_text }}</v-snackbar>

        <!-- Transaction History start -->
        <!-- <v-dialog v-model="transaction_history" max-width="400px"  persistent>
            <v-card class="mx-auto" max-width="400" style="min-height:450px">

                <v-toolbar color="#0F9750" dark>
                <v-toolbar-title class="modal_title">Transaction History</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="ClosePopUp()" title="Close"> <v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                
                <v-list two-line>
                <v-list-item-group v-model="selected" active-class="blue--text">
                   
                    <template v-for="(item, index) in items">
                    <v-list-item :key="item.index" title="Click here to view detail">
                        <template v-slot:default="{ active }">
                            <v-list-item-content>
                                <v-list-item-title class="DateStyle">{{item.date}}</v-list-item-title>
                                <v-list-item-subtitle class="text--primary">{{item.headline}}</v-list-item-subtitle>
                                <v-list-item-subtitle>{{item.vendor}}</v-list-item-subtitle>


                                <v-list-item-title v-if="active" class="paid_with">Paid with</v-list-item-title>
                                <v-list-item-subtitle v-if="active" class="details">VISA ****3148</v-list-item-subtitle>
                                <v-list-item-title v-if="active" class="details">Seller Info</v-list-item-title>
                                <v-list-item-subtitle v-if="active" class="details">Chaldal</v-list-item-subtitle>
                                <v-list-item-title v-if="active" class="details">Invoice ID</v-list-item-title>
                                <v-list-item-subtitle v-if="active" class="details">861742F79104FE56</v-list-item-subtitle>

                                <v-list-item-title v-if="active" class="details">Purchase details</v-list-item-title>
                                <v-list-item-subtitle v-if="active" class="details">Order # 6457079</v-list-item-subtitle>
                                <v-list-item-title v-if="active" class="details">Date</v-list-item-title>
                                <v-list-item-subtitle v-if="active" class="details">22 Oct, 2021 12:28pm</v-list-item-subtitle>

                            </v-list-item-content>

                        <v-list-item-action>
                            <v-list-item-action-text class="amount_style">{{item.amount}}</v-list-item-action-text>
                            <v-icon v-if="!active" color="grey lighten-1" size="35px">mdi-menu-down</v-icon>
                            <v-icon v-else color="primary" size="35px">mdi-menu-up</v-icon>
                        </v-list-item-action>
                        </template>
                    </v-list-item>

                    <v-divider
                        v-if="index < items.length - 1"
                        :key="index"
                    ></v-divider>
                    
                    </template>
                   
                </v-list-item-group>
                </v-list>

               <v-card-actions 
                style="background-color:#f2f2f2;cursor:pointer"
                class="justify-center"
                @click="GoMorePage()"
                v-if="isTransactionMoreThanFive"
                >
                    <v-btn text large class="more_btn_class">More ...</v-btn>
               </v-card-actions>
                

            </v-card>
            
        </v-dialog> -->
        

    </div>
     
</template>

<script>
const pg_url = require('../../pg_url');
import axios from "axios";
export default {

    data: () => ({
        transaction_history:false,
        isTransactionMoreThanFive:false,

        customer_api_base_url: pg_url.customer_api_base_url,

        // Profile information
        customer_name: "",
        mobile_no: "",

        // Reset PIN flow: 'none' | 'otp' | 'set'
        resetPinStep: "none",
        otp: "",
        newPin: "",
        newPinConfirm: "",
        resendTimer: 0,
        resendDisabled: false,
        resendInterval: null,

        // Local snackbar
        snackbar: false,
        color: "#0F9750",
        timeout: 4000,
        popup_text: "",

        selected: [0],
        items: [
        {
          amount: 'BDT 1025',
          headline: 'Payment',
          vendor: 'Pranisheba Shop',
          date: '25 March 2021',
        },
        {
          amount: 'BDT 85523',
          headline: 'Payment',
          vendor: 'Chaldal',
          date: '10 January 2021',
        },
        {
          amount: 'BDT 180',
          headline: 'Payment',
          vendor: 'Pranisheba Shop',
          date: '08 February 2020',
        },
        {
          amount: 'BDT 9999',
          headline: 'Payment',
          vendor: 'Daraz',
          date: '10 January 2020',
        },
        {
          amount: 'BDT 780',
          headline: 'Payment',
          vendor: 'Pranisheba Shop',
          date: '19 August 2021',
        },
      ],
      }),

    computed: {
        masked_mobile_no() {
            return this.maskPhoneNumber(this.mobile_no);
        },
    },

    mounted() {
        
        // transaction history dynamic
        var trx_items_no = this.items.length;
        if(trx_items_no>=5){
            this.isTransactionMoreThanFive = true;
        }
        else{
            this.isTransactionMoreThanFive = false;
        }

        // Load the logged-in customer's profile (name + phone)
        this.getProfile();

    },

    methods: {

        getCookie(name) {
            var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
            return match ? match[2] : "";
        },

        onlyAllowNumbers(event) {
            var char = String.fromCharCode(event.keyCode || event.which);
            if (!/[0-9]/.test(char)) {
                event.preventDefault();
            }
        },

        maskPhoneNumber(phone) {
            var digits = String(phone || "").replace(/\D/g, "");
            if (!digits) {
                return "—";
            }
            if (digits.length <= 7) {
                return digits;
            }
            return digits.slice(0, 4) + "***" + digits.slice(-4);
        },

        showMessage(text, color) {
            this.popup_text = text;
            this.color = color || "#0F9750";
            this.timeout = 3000;
            this.snackbar = true;
        },

        // Fetch the logged-in customer's name and phone number.
        getProfile() {
            var customer_token = this.getCookie("token");
            if (!customer_token) {
                return;
            }
            axios
                .request({
                    method: "POST",
                    url: this.customer_api_base_url + "customer-token-check",
                    headers: { Authorization: "Bearer " + customer_token },
                })
                .then((response) => {
                    if (response.data.sp_code == "200") {
                        this.customer_name = response.data.customer_name || "";
                        this.mobile_no = response.data.mobile_no || "";
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        // Reset PIN step 1: send an OTP to the customer's mobile number.
        startResetPin() {
            if (!this.mobile_no) {
                this.showMessage("Unable to load your mobile number", "red");
                return;
            }
            axios
                .post(this.customer_api_base_url + "customer-forgot-pass", {
                    mobile_no: this.mobile_no,
                })
                .then((response) => {
                    var data = response.data;
                    if (data.sp_code === "200") {
                        this.resetPinStep = "otp";
                        this.otp = "";
                        this.startResendTimer();
                        this.showMessage("OTP sent to reset your PIN", "success");
                    } else if (data.sp_code === "403") {
                        this.showMessage(data.message, "red");
                    } else {
                        this.showMessage(data.message || "Failed to send OTP", "red");
                    }
                })
                .catch(() => {
                    this.showMessage("Failed to send OTP", "red");
                });
        },

        // Reset PIN step 2: move to the set-new-PIN screen.
        continueResetPin() {
            if (!this.otp || this.otp.length < 4) {
                this.showMessage("Please enter the OTP", "red");
                return;
            }
            this.resetPinStep = "set";
            this.newPin = "";
            this.newPinConfirm = "";
        },

        // Reset PIN step 3: verify OTP and save the new PIN.
        submitResetPin() {
            if (!this.newPin || this.newPin.length !== 4) {
                this.showMessage("PIN must be 4 digits", "red");
                return;
            }
            if (this.newPin !== this.newPinConfirm) {
                this.showMessage("PIN and Confirm PIN do not match", "red");
                return;
            }
            var token = this.$route.query.token;
            axios
                .post(
                    this.customer_api_base_url + "customer-reset-pin",
                    {
                        mobile_no: this.mobile_no,
                        verify_code: this.otp,
                        pin: this.newPin,
                        pin_confirmation: this.newPinConfirm,
                    },
                    { headers: { Authorization: "Bearer " + token } }
                )
                .then((response) => {
                    var data = response.data;
                    if (data.sp_code === "200") {
                        this.showMessage("Your PIN has been reset successfully", "success");
                        this.cancelReset();
                    } else if (data.sp_code === "101") {
                        this.showMessage("Entered OTP does not match", "red");
                        this.resetPinStep = "otp";
                    } else if (data.sp_code === "103") {
                        this.showMessage("OTP expired. Please resend", "red");
                        this.resetPinStep = "otp";
                    } else {
                        this.showMessage(data.message || "PIN reset failed", "red");
                    }
                })
                .catch(() => {
                    this.showMessage("PIN reset failed. Please try again", "red");
                });
        },

        // Cancel reset and return to the profile view.
        cancelReset() {
            this.resetPinStep = "none";
            this.otp = "";
            this.newPin = "";
            this.newPinConfirm = "";
            if (this.resendInterval) {
                clearInterval(this.resendInterval);
            }
        },

        startResendTimer() {
            this.resendTimer = 60;
            this.resendDisabled = true;
            if (this.resendInterval) {
                clearInterval(this.resendInterval);
            }
            this.resendInterval = setInterval(() => {
                if (this.resendTimer <= 0) {
                    clearInterval(this.resendInterval);
                    this.resendDisabled = false;
                    return;
                }
                this.resendTimer--;
            }, 1000);
        },

        transactionHistory(){
          this.transaction_history = true;
        },

        ClosePopUp(){
            this.transaction_history = false;
        },

        GoMorePage(){
            console.log("Go more page...");
        }
    }


  
}
</script>

<style scoped>

    .row_style{
        margin-bottom:-23px !important;
    }
    .account_text{
        font-size: 16px;
        font-weight: bolder;
        text-transform:none;
        color:black;
        font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
        text-align: center !important;
    }
    .account_text2{
        font-size: 15px;
        font-weight: bold;
        color:#48494c;
        font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
    }
    .profile_name{
        font-size: 18px;
        font-weight: bolder;
        color:#0F9750;
        font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
    }
    .profile_phone{
        font-size: 14px;
        color:#48494c;
        font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
    }
    .reset_title{
        font-size: 17px;
        font-weight: bold;
        text-align: center;
        color:#0F9750;
        margin-bottom: 6px;
        font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
    }
    .DateStyle{
        font-size: 16px;
        font-weight: bolder;
        font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
    }
    .details{
        margin-left:10px !important;
        font-size:13px !important;
        font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
        border: none !important;
    }
    .paid_with{
        margin-top:10px;
        margin-left:10px;
        font-size:13px !important;
        font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
    }
    .more_btn_class{
        text-transform: none;
        font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
        font-size: 16px;
        font-weight: bolder;
        color:black;
       
    }

    .amount_style{
        color: black !important;
        font-size: 14px;
        font-weight: bolder;
        font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;

    }
    .modal_title{
        font-size: 20px;
        font-weight: bolder;
        font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
    }
    

    /* Responsive */
    @media only screen and (min-width: 370px) and (max-width: 406px) {
        .account_text{
            font-size: 14px;
            font-weight: normal !important;
            text-transform:none;
            color:rgb(0, 0, 0) !important;
            font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
            text-align: center !important;
      }
    }

    @media only screen and (min-width: 310px) and (max-width: 370px) {
        .account_text{
            font-size: 10px;
            font-weight: normal !important;
            text-transform:none;
            color:rgb(0, 0, 0) !important;
            font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
            text-align: center !important;
      }
    }
    
    
</style>